module.exports = __webpack_public_path__ + "static/img/1.b82e541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/1.png
// module id = yb/V
// module chunks = 0